const productPlaceholderImage = new URL(
  '../../assets/images/product-placeholder.jpg',
  import.meta.url,
).href;

export { productPlaceholderImage };
